<template functional>
  <div class="radio-border-container">
    <span class="radio-border radio-border__hz radio-border__top"/>
    <span class="radio-border radio-border__vt radio-border__right"/>
    <span class="radio-border radio-border__hz radio-border__bottom"/>
    <span class="radio-border radio-border__vt radio-border__left"/>
  </div>
</template>

<script>
  export default {
    name: 'RadioBorder',
  };
</script>
<style lang="scss">
.radio-border-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: $global-border-radius;
}

.radio-border {
    position: absolute;
    display: inline-block;
    background-color: $turquoise;
    transition-timing-function: $radio-border-transition-easing;
    transition-duration: $radio-border-transition-duration;
    transition-property: transform;
}

.radio-border__hz {
    left: 0;
    width: 100%;
    height: $radio-border-size;
    transform: scaleX(0);
}

.radio-border__vt {
    top: 0;
    width: $radio-border-size;
    height: 100%;
    transform: scaleY(0);
}

.radio-border__top {
    top: 0;
    transition-delay: $radio-border-transition-duration*3;
    transform-origin: left;
}

.radio-border__right {
    right: 0;
    transition-delay: $radio-border-transition-duration*2;
    transform-origin: top;
}

.radio-border__bottom {
    bottom: 0;
    transition-delay: $radio-border-transition-duration;
    transform-origin: right;
}

.radio-border__left {
    left: 0;
    transform-origin: bottom;
}

.radio-input + .border-container {
    opacity: 0;
}

.icon__radio-label_container,
.button__radio-label_container,
.emoji__radio-label_container {
    .radio-border-container {
        top: -$radio-border-size;
        left: -$radio-border-size;
        width: calc(100% + #{$radio-border-size} * 2);
        height: calc(100% + #{$radio-border-size} * 2);
    }
}

.radio-input:checked + .radio-border-container,
.radio-input:focus + .radio-border-container {
    opacity: 1;

    .radio-border {
        transition-timing-function: $radio-border-transition-easing;
        transition-duration: $radio-border-transition-duration;
        transition-property: transform;
    }

    .radio-border__hz {
        transform: scaleX(1);
    }

    .radio-border__vt {
        transform: scaleY(1);
    }

    .radio-border__top {
        transition-delay: 0ms;
        transform-origin: left;
    }

    .radio-border__right {
        transition-delay: $radio-border-transition-duration;
        transform-origin: top;
    }

    .radio-border__bottom {
        transition-delay: $radio-border-transition-duration*2;
        transform-origin: right;
    }

    .radio-border__left {
        transition-delay: $radio-border-transition-duration*3;
        transform-origin: bottom;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/RadioBorder.vue